import { AxiosError } from 'axios';

export function identifyApiErrorCode(error: unknown): string | null {
    if (typeof error !== 'object' || error === null || !('response' in error)) {
        return null;
    }
    const response = error.response;
    if (
        typeof response !== 'object' ||
        response === null ||
        !('data' in response)
    ) {
        return null;
    }
    const data = response.data;
    if (typeof data !== 'object' || data === null) {
        return null;
    }

    if ('errorCode' in data && typeof data.errorCode === 'string') {
        return data.errorCode;
    }
    if ('error_code' in data && typeof data.error_code === 'string') {
        return data.error_code;
    }
    return null;
}

export function identifyApiErrorStatus(error: unknown): number | undefined {
    if (typeof error !== 'object' || error === null || !('response' in error)) {
        return undefined;
    }
    const response = error.response;
    if (
        typeof response !== 'object' ||
        response === null ||
        !('status' in response)
    ) {
        return undefined;
    }
    return typeof response.status === 'number' ? response.status : undefined;
}

export function createApiErrorWithCode(errorCode: string, status = 400) {
    return {
        response: {
            status,
            data: { errorCode },
        },
    } as AxiosError;
}
